import React, { useState, useRef, useEffect, useContext } from 'react';
import './SearchBarMob.css';
import { CartContext } from '../cart/ContextProvider';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { useNavigate } from 'react-router';

const MobileSearchBar = (props) => {
    const { searchResult, setSearchResult } = useContext(CartContext);
    const [searchText, setSearchText] = useState('');
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const searchContainerRef = useRef(null);
    const navigate = useNavigate();

    const customStyle = {
        margin : props.margin
    }

    

    const handleSearch = async () => {
        if (searchText === null || searchText === '') {
            console.log("Couldn't search");
        }
        else {
            try {
                const response = await axios.get(`https://jackpotbackend.vercel.app/search/${searchText}`);
                console.log(searchResult);
                setSearchResult(response.data.results);
                setClicked(false)
                setSuggestions([])


                navigate(`/search`)
            } catch (error) {
                console.log("error " + error);
            }

        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    const handleClick = (id) => {
        setClicked(false)
        setSearchText('')
        setShowSearchBar(false)
        setSuggestions([])
        navigate(`/product/${id}`)
    }


    const handleInputChange = async (event) => {
        const text = event.target.value;
        setSearchText(text);
        setSuggestions([])
        if (text.length > 2) {
            try {
                const response = await axios.get(`https://jackpotbackend.vercel.app/search/${searchText}`);
                setSuggestions(response.data.results)
            } catch (error) {
                console.log("error " + error);
            }
        }
    };


    const handleClickOutside = (event) => {
        if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
            setClicked(false);
        }
    };


    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    return (
        <div className='totalMobSearch'>
            <div
                ref={searchContainerRef}
                onMouseEnter={() => setShowSearchBar(true)}
                onMouseLeave={() => setShowSearchBar(!!searchText)}
                onClick={() => setClicked(true)}
                className='Mobsearch '
                style={customStyle}
            >
                <>
                    <input
                        onFocus={() => setShowSearchBar(true)}
                        onBlur={() => setShowSearchBar(!!searchText)}
                        id="Mobsearchbar"
                        type='text'
                        placeholder="Find your perfect style..."
                        value={searchText}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                    {clicked && suggestions.length > 0 ? (<div className='dropdown_menu'>
                        <ul>
                            {
                                suggestions.map((suggestion) => (
                                    <li onClick={() => handleClick(suggestion.id)} key={suggestion.id}>{suggestion.name}</li>
                                ))
                            }
                        </ul>
                    </div>) : null}
                    <SearchIcon onClick={handleSearch} className='searchIcon'></SearchIcon>
                </>
            </div>
        </div>
    );
};

export default MobileSearchBar;